<template>
  <div>
    <unicom-barra-pesquisa-v2
      v-model="valorBarraPesquisa"
      @limpar-campos="limparCampoPesquisa"
      placeholder="Busque por um grupo de serviço..."
    />
    <div
      class="scroll-pilulas scroll-design"
      v-if="listaGrupoServicosComputed.length > 0"
    >
      <PilulaGrupoServico
        v-for="(grupo, index) in listaGrupoServicosComputed"
        :key="index"
        style="display: inline-block; margin-right: 8px; margin-bottom: 16px"
        :texto="grupo"
      />
    </div>
    <div class="pilulas-vazia medio negrito" v-else>
      Não contém nenhum grupo de serviço
    </div>
  </div>
</template>

<script>
import PilulaGrupoServico from "./PilulaGrupoServico";

export default {
  components: {
    PilulaGrupoServico
  },
  props: {
    listaGrupoServicos: {
      type: Array,
      default: () => {
        return [];
      }
    }
  },
  data() {
    return {
      valorBarraPesquisa: ""
    };
  },
  methods: {
    limparCampoPesquisa() {
      this.valorBarraPesquisa = "";
    },
    normalizeText(str) {
      return str
        .toString()
        .normalize("NFD")
        .replace(/[\u0300-\u036f]/g, "");
    },
    filtroGenerico(queryText, textoDoItem) {
      const hasValue = val => (val != null ? val : "");

      const text = hasValue(this.normalizeText(textoDoItem));
      const query = hasValue(this.normalizeText(queryText));

      return (
        text
          .toString()
          .toLowerCase()
          .indexOf(query.toString().toLowerCase()) > -1
      );
    },
    filtragemDosItems() {
      if (this.listaGrupoServicos.length <= 0) return [];

      return this.listaGrupoServicos.filter(e => {
        return this.filtroGenerico(this.valorBarraPesquisa, e);
      });
    }
  },
  computed: {
    listaGrupoServicosComputed() {
      return this.filtragemDosItems();
    }
  }
};
</script>

<style lang="scss" scoped>
.scroll-pilulas {
  height: 113px;
  overflow: hidden auto;
  margin-top: 16px;
}

.pilulas-vazia {
  height: 113px;
  display: flex;
  margin-top: 16px;
  align-items: center;
  justify-content: center;
}
</style>
